/******************************************/
/******************************************/
//SUCCESS CODE
//Toggleing forms being displayed or Success Message being displayed. 
document.addEventListener('DOMContentLoaded', function() {
  //console.log('request loader')
  const from_success = window.location.search.substring(1)
  if (from_success.includes("true")) {
    const hash = window.location.hash.substring(1);
    console.log('request loader',hash)
    if(hash.includes('request_quote')){
      //console.log('request loader','request_quote')
      document.getElementById('request-quote-success-id')?.style && 
        (document.getElementById('request-quote-success-id').style.display = 'block');
      document.getElementById('request-quote-id-form')?.style && 
        (document.getElementById('request-quote-id-form').style.display = 'none');
      document.getElementById('rfq-id-form')?.style && 
        (document.getElementById('rfq-id-form').style.display = 'block');
    }else if(hash.includes('RFQ-form')){
      document.getElementById('rfq-success-id')?.style && 
        (document.getElementById('rfq-success-id').style.display = 'block');
      document.getElementById('rfq-id-form')?.style && 
        (document.getElementById('rfq-id-form').style.display = 'none');
      document.getElementById('request-quote-id-form')?.style && 
        (document.getElementById('request-quote-id-form').style.display = 'block');
    }else{
      // if it gets here there was a error with the url strings
      //Make all forms Visible and Success Messages Hidden
      document.getElementById('request-quote-success-id')?.style && 
        (document.getElementById('request-quote-success-id').style.display = 'none');
      document.getElementById('request-quote-id-form')?.style && 
        (document.getElementById('request-quote-id-form').style.display = 'block');
      document.getElementById('rfq-success-id')?.style && 
        (document.getElementById('rfq-success-id').style.display = 'none');
      document.getElementById('rfq-id-form')?.style && 
        (document.getElementById('rfq-id-form').style.display = 'block');
    }
  }else{
    //Make all forms Visible and Success Messages Hidden
    document.getElementById('request-quote-success-id')?.style && 
      (document.getElementById('request-quote-success-id').style.display = 'none');
    document.getElementById('request-quote-id-form')?.style && 
    (document.getElementById('request-quote-id-form').style.display = 'block');
    document.getElementById('rfq-success-id')?.style && 
      (document.getElementById('rfq-success-id').style.display = 'none');
    document.getElementById('rfq-id-form')?.style && 
      (document.getElementById('rfq-id-form').style.display = 'block');
  }
});

//console.log('jQuery loader')
// this is only for the request quote request thank you page. 
// Quick Quote
const h2 = document?.querySelector('#pnl-thank-you h2');
if(h2?.innerHTML){
  h2.innerHTML = h2?.innerHTML?.replace(/\.(<\/?[^>]+>)*\s*/, '.<br><hr><br>');
}
(function() {
  function waitForjQuery() {
    if (typeof jQuery !== 'undefined') {
      jQuery(document).ready(function($) {
        

        

    
    
    /******************************************/
    /******************************************/
    // Grab all your CSS vars in one go
    const cssVars = {
      headerTopBarColor: getComputedStyle(document.documentElement).getPropertyValue('--header-top-bar-color').trim(),
      
      lightGreyBorder: getComputedStyle(document.documentElement).getPropertyValue('--light-grey-border').trim(),
      lightGreyBg: getComputedStyle(document.documentElement).getPropertyValue('--light-grey-bg').trim(),
      lightBlueBorder: getComputedStyle(document.documentElement).getPropertyValue('--light-blue-border').trim(),
      lightBlueBg: getComputedStyle(document.documentElement).getPropertyValue('--light-blue-bg').trim(),

      blueDefault: getComputedStyle(document.documentElement).getPropertyValue('--blue-default').trim(),
      blueHover: getComputedStyle(document.documentElement).getPropertyValue('--blue-hover').trim(),
      blueActive: getComputedStyle(document.documentElement).getPropertyValue('--blue-active').trim(),
      hrBlueBg: getComputedStyle(document.documentElement).getPropertyValue('--hr-blue-bg').trim(),

      shadowColor: getComputedStyle(document.documentElement).getPropertyValue('--shadow-color').trim(),
      shadowColorHover: getComputedStyle(document.documentElement).getPropertyValue('--shadow-color-hover').trim(),

      successColorBg: getComputedStyle(document.documentElement).getPropertyValue('--success-color-bg').trim(),
      successColorBorder: getComputedStyle(document.documentElement).getPropertyValue('--success-color-border').trim(),
      errorColorBg: getComputedStyle(document.documentElement).getPropertyValue('--error-color-bg').trim(),
      errorColorBorder: getComputedStyle(document.documentElement).getPropertyValue('--error-color-border').trim(),
    };
    var bgType = '';
    $('.click-cell').click(function() {   
      var tagType = $(this).prop("tagName");
      var datapage = $(this).data('page');
      if ((tagType == "LI") && (datapage.toLowerCase().indexOf("workload") >= 0)){ 
          //console.log(tagType)
          window.open("/collections/"+datapage, '_blank'); 
      }else{
        //console.log(datapage);
        window.open(datapage, '_blank');  
      }
    });
    $('.click-cell').hover(
      function() {
        bgColorOrig = $(this).css("background-color");
        textColorOrig = $(this).css("color");
        
        var tagType = $(this).prop("tagName");
        const classList = $(this).attr("class").split(" ");
        const blueHover = classList.some(className => className.includes("blue-hover-bg"));

        if (tagType == "TD"){
          $(this).css({"background-color": "#08a0e5", "color": "white"});
        }else if (tagType == "TH") { 
          $(this).css({"background-color": "#08a0e5", "color": "#999999"}); 
        }else if (tagType == "LI" || tagType == "P" || tagType == "DIV")  { 
          if(blueHover){
            $(this).css({"background-color": cssVars.lightBlueBg, "color": cssVars.blueHover}); 
          }else{
            $(this).css({"background-color": "#fefefe", "color": cssVars.blueHover}); 
          } 
        }
      },
      function() {
        var tagType = $(this).prop("tagName");
        
        if (tagType == "TD"){ 
          $(this).css({"background-color": "white", "color": "#08a0e5"}); 
        }else if (tagType == "TH") { 
          $(this).css("color", "#08a0e5"); 
        }else if (tagType == "LI" || tagType == "P" || tagType == "DIV" ) { 
          $(this).css({"background-color": bgColorOrig, "color": textColorOrig}); 
        }
      }
    );

    $( "#accordion" ).accordion({ heightStyle: "content", collapsible: true, active: false });
    $( "#accordionPI" ).accordion({ heightStyle: "content", collapsible: true, active: false });
    $( "#accordionDescription" ).accordion({ heightStyle: "content", collapsible: true, active: false });
    $( "#accordionDescription1" ).accordion({ heightStyle: "content", collapsible: true, active: false });
    $( "#accordionDescription2" ).accordion({ heightStyle: "content", collapsible: true, active: false });
    $( "#accordionDescription3" ).accordion({ heightStyle: "content", collapsible: true, active: false });
    $( "#accordionDescriptionDataCable" ).accordion({ heightStyle: "content", collapsible: true, active: false });


    
      });
    } else {
      // Try again in 50ms
      setTimeout(waitForjQuery, 50);
    }
  }
  waitForjQuery();
})();


